// No mainnet in this explorer - always returns false
export function useGetInMainnet(): boolean {
  return false;
}
